import { RestUrl } from "../../common/cyan.types";

export class StudySmsUrl {
  public static sendEcoaAccessSms: RestUrl = ["POST", "/subject/ecoa-access/send"];
  public static sendEcoaAuthenticateSms: RestUrl = ["POST", "/subject/ecoa-authenticate/send"];
  public static createSubjectSmsHistoryDownloadUrl: (studyId: bigint) => RestUrl = studyId => [
    "POST",
    `/studies/${studyId}/subjects/sms/download`,
  ];
}
